

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {CTQueryBuilderComponent} from './ctquerybuilder.component';
import { QueryBuilderModule } from "angular2-query-builder";
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
 imports:      [ CommonModule,FormsModule,QueryBuilderModule,NgSelectModule ], //here we add common and formmodule see documentation in sharing Module
 declarations: [ CTQueryBuilderComponent],
 exports:      [CommonModule,FormsModule,CTQueryBuilderComponent,NgSelectModule ] //here we add common and formmodule see documentation in sharing Module
})
export class CTQueryModule { }